document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        const header = item.querySelector('.faq-item__header');
        
        header.addEventListener('click', () => {
            const isActive = item.classList.contains('active');

            // Close others (optional, keep for a refined experience)
            faqItems.forEach(other => {
                if (other !== item) other.classList.remove('active');
            });

            if (isActive) {
                item.classList.remove('active');
            } else {
                item.classList.add('active');
            }
        });
    });
});
